// extracted by mini-css-extract-plugin
module.exports = {"text":"Trayectoria_text__JjLr1","card":"Trayectoria_card__12oKt"};